// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   Global Layout
========================= */

* {
    box-sizing: border-box;
}

body {
    background-color: #f4f6f8;
    font-family: Arial, Helvetica, sans-serif;
    margin: 0;
    padding: 0;
}


.Anagrams_gameLayout__0t7Jp {
   display: grid;
   justify-content: center;
   padding: 1rem;
   margin: 0 2vw;
   grid-template-columns: repeat(12, [col-start] 1fr);
   grid-template-rows: repeat(12, auto);
   gap: 20px;
}

.Anagrams_gameLayout__0t7Jp > * {
   grid-column: col-start / span 12;
   
}
.Anagrams_timer__zoPa- {
    display: flex;
    justify-content: flex-end;
    align-items: center;
   
    width: 100%;

    margin-bottom: 1rem;
}

.Anagrams_playerCountRight__pnzw0 { 
   grid-column: 11 / span 2;
   grid-row: 1 / span 1;
   justify-self: center;
   font-weight: 800;
   font-size: 20px;
}
.Anagrams_playerCountLeft__SemmF { 
   grid-column: 1 / span 2;
   grid-row: 2 / span 1;
   justify-self: center;
   font-weight: 800;
   font-size: 20px;
}

.Anagrams_shuffleBtn__DQwKe {
    width: 75px;
    height: 75px;
    padding: 0;
    margin: 0;
    border-radius: 12px;
}
.Anagrams_shuffleImg__bgWdI {
    object-fit: contain;
    width: 100%;
    height: 100%;
    justify-self: center;
}



@media (max-width: 768px) {
    .Anagrams_timer__zoPa- {
        justify-content: center;
    }
}

/* =========================
   Points
========================= */

.Anagrams_points__a59dN {
    text-align: center;
    margin-top: 20px;
    color: #1e293b;
}

.Anagrams_points__a59dN h2 {
    margin: 0;
    font-size: 2rem;
}

/* =========================
   Word Count Sidebar
========================= */

.Anagrams_wordCountSidebar__ZFgsV {
    width: 220px;
    justify-self: center;
}

.Anagrams_WordCountPanel__7yChM {
    background-color: white;
    border-radius: 15px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
    border: 1px solid #d6dde5;
    overflow: hidden;
}

.Anagrams_WordCountPanel__7yChM h3 {
    margin: 0;
    padding: 12px;
    background-color: #865AA6;
    color: white;
    text-align: center;
}

.Anagrams_WordCountRow__olj9K {
    display: flex;
    justify-content: space-between;
    padding: 10px 14px;
    border-bottom: 1px solid #e2e8f0;
}

.Anagrams_WordCountRow__olj9K:last-child {
    border-bottom: none;
}

.Anagrams_WordCountRow__olj9K:nth-child(even) {
    background-color: #f8fafc;
}

/* =========================
   Letter Display
========================= */

.Anagrams_letterRow__2F7cl {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-top: 30px;
}

.Anagrams_letter__Ovodk {
    width: clamp(50px, 10vw, 75px);
    height: clamp(50px, 10vw, 75px);

    font-size: clamp(1.25rem, 4vw, 2rem);
    font-weight: bold;

    border: none;
    border-radius: 12px;

    background-color: #d7aef2;
    color: black;

    cursor: pointer;

    transition: all 0.2s ease;

    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);

    text-transform: uppercase;
}

.Anagrams_letter__Ovodk:hover {
    background-color: #1d4ed8;
    transform: translateY(-2px);
}

.Anagrams_letter__Ovodk:active {
    transform: scale(0.95);
}

.Anagrams_used__CQuqt {
    background-color: #865AA6;
}

/* =========================
   Buttons
========================= */

.Anagrams_buttons__lI10n {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    width: 100%;
}

.Anagrams_start__mu77T,
.Anagrams_end__bwGPy {
    color: white;
    border: none;
    border-radius: 8px;
    padding: 12px 24px;

    font-size: 1rem;
    font-weight: bold;

    cursor: pointer;
    transition: 0.2s ease;
}

.Anagrams_start__mu77T {
    background-color: #1A78A3;
}

.Anagrams_end__bwGPy {
    background-color: #91191d;
}

.Anagrams_start__mu77T:hover {
    background-color: #16698e;
}

.Anagrams_end__bwGPy:hover {
    background-color: #7c1519;
}

.Anagrams_start__mu77T:active,
.Anagrams_end__bwGPy:active {
    transform: scale(0.97);
}

/* =========================
   Letter Count Buttons
========================= */

.Anagrams_letterCountRow__X4vQN {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 15px;
    z-index: 1;
}

.Anagrams_LetterCountButton__o2DUC {
    width: 45px;
    height: 45px;

    border: 1px solid #888;
    border-radius: 8px;

    background-color: #6b7280;
    color: white;

    font-size: 1rem;
    font-weight: bold;

    cursor: pointer;
    transition: 0.2s ease;
}

.Anagrams_LetterCountButton__o2DUC:hover {
    background-color: #4b5563;
}

.Anagrams_LetterCountButton__o2DUC:active {
    transform: scale(0.95);
}

/* =========================
   Guess Input
========================= */

.Anagrams_guess__LEpHK {
    text-align: center;
}

.Anagrams_guess__LEpHK label {
    font-size: 1.1rem;
    font-weight: bold;
    color: #334155;
}

.Anagrams_guess__LEpHK input {
    width: min(300px, 90vw);

    margin-top: 10px;
    padding: 10px;

    font-size: 1rem;
    text-transform: uppercase;

    border: 2px solid #cbd5e1;
    border-radius: 8px;

    outline: none;
}

.Anagrams_guess__LEpHK input:focus {
    border-color: #2563eb;
}

/* =========================
   Response Messages
========================= */

.Anagrams_guessText__F-LMh {
    text-align: center;
    min-height: 40px;
    margin-top: 15px;
}

.Anagrams_guessText__F-LMh p {
    display: inline-block;

    background-color: white;

    border-radius: 8px;

    padding: 10px 20px;

    font-weight: bold;
    color: #334155;

    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

/* =========================
   End Game Screen
========================= */

.Anagrams_GameEnd__E2YJx {
    margin-top: 25px;
    display: flex;
    justify-content: center;
    grid-row: 9
}

.Anagrams_EndResult__5ckRW {
    background-color: white;

    width: 600px;
    max-width: 95%;

    padding: 25px;

    border-radius: 15px;

    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}

.Anagrams_EndResult__5ckRW h1 {
    text-align: center;
    color: #1e293b;
}

/* =========================
   Scrollable Word List
========================= */

.Anagrams_WordList__g31cf {
    margin-top: 20px;
    max-height: 450px;
    overflow-y: auto;
    padding-right: 8px;
}

.Anagrams_WordList__g31cf h3 {
    margin-bottom: 5px;
    color: #334155;
}

.Anagrams_WordList__g31cf::-webkit-scrollbar {
    width: 8px;
}

.Anagrams_WordList__g31cf::-webkit-scrollbar-thumb {
    background-color: #1A78A3;

    border-bottom: 1px solid #d1d9e0;
}

.Anagrams_Word__YEYQf {
    display: block;
    padding-left: 15px;
}

.Anagrams_Word__YEYQf.Anagrams_guessed__Y8f0n {
    background-color: #a3e635;
    color: black;
    font-weight: bold;
}

/* ============================
      SETTINGS MENU
============================== */
.Anagrams_settingsForm__F6k-c {
    background: #1e1e1e;
    padding: 1.5rem;
    border-radius: 12px;
    border: 1px solid #444;
    max-width: 300px;
    color: white;
}

.Anagrams_settingsForm__F6k-c h3 {
    margin-top: 0;
    margin-bottom: 1rem;
    text-align: center;
}

.Anagrams_settingsGroup__OpJm0 {
    margin-bottom: 1rem;
}

.Anagrams_settingsGroup__OpJm0 label {
    display: block;
    font-weight: bold;
    margin-bottom: 0.25rem;
}

.Anagrams_settingsGroup__OpJm0 input {
    width: 100%;
    box-sizing: border-box;
    padding: 0.6rem;
    border: 1px solid #555;
    border-radius: 6px;
    background-color: #2c2c2c;
    color: white;
    font-size: 1rem;
}

.Anagrams_settingsGroup__OpJm0 input:focus {
    outline: none;
    border-color: #4cafef;
    box-shadow: 0 0 5px rgba(76, 175, 239, 0.5);
}

.Anagrams_settingsSave__0Yq\\+i {
    width: 100%;
    padding: 0.75rem;
    border: none;
    border-radius: 8px;
    background-color: #28a745;
    color: white;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.Anagrams_settingsSave__0Yq\\+i:hover {
    background-color: #218838;
}

.Anagrams_settingsSave__0Yq\\+i:active {
    transform: scale(0.98);
}
.Anagrams_settingsGroup__OpJm0 input::placeholder {
    color: #999;
    opacity: 1;
    font-style: italic;
}

/* ===========================
      MOBILE LAYOUT 
============================== */

.Anagrams_gameId__bS6fz {
    position: sticky;
    top: 10px;
    width: 115px;
    height: 35px;
    left: 15px;
    background: rgba(0, 0, 0, 0.85);
    color: white;
    padding: 8px 14px;
    border-radius: 8px;
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 1px;
    z-index: 1000;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    grid-row: 1 / span 1;
}
.Anagrams_leaderboard__E2\\+1S {
    margin-top: 2rem;

    background: #ffffff;
    border-radius: 16px;

    padding: 1.5rem;

    max-width: 400px;
    margin-left: auto;
    margin-right: auto;

    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
}

.Anagrams_leaderboard__E2\\+1S h2 {
    text-align: center;
    margin-bottom: 1rem;
}
.Anagrams_player__9vXlL {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 12px 16px;
    margin-bottom: 10px;

    background: #f4f4f4;
    border-radius: 10px;

    font-size: 1.1rem;
    font-weight: 600;

    transition: all 0.2s ease;
}

.Anagrams_player__9vXlL:hover {
    background: #e9e9e9;
    transform: scale(1.02);
}


@media (min-width: 768px) {

   .Anagrams_timer__zoPa- {
      grid-column: 10 / span 3;
      grid-row: 1;
      margin-bottom: 0;
      align-items: center;
      justify-content: center;
   }
   
   .Anagrams_points__a59dN { 
      grid-column: col-start / span 12;
      grid-row: 2;
   }

   .Anagrams_letterRow__2F7cl {
      grid-column: col-start / span 12;
      grid-row: 3;
   }

   .Anagrams_wordCountSidebar__ZFgsV {
      grid-column: col-start / span 3;
      grid-row: 4 / span 9;
      justify-self: left;
   }

   .Anagrams_buttons__lI10n {
      grid-column: 4 / span 6;
      grid-row: 5;
      gap: 2em;
   }
   .Anagrams_start__mu77T .Anagrams_end__bwGPy {
      width: 12vw;
   }
   .Anagrams_guess__LEpHK {
      grid-row: 6 / span 2;
   }

   .Anagrams_guessText__F-LMh {
      grid-row: 8;
   }

   .Anagrams_letterCountRow__X4vQN {
      grid-row: 6;
      z-index: 1
   }
   
   

   

   

}

`, "",{"version":3,"sources":["webpack://./src/css/Anagrams.module.css"],"names":[],"mappings":"AAAA;;2BAE2B;;AAE3B;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,yCAAyC;IACzC,SAAS;IACT,UAAU;AACd;;;AAGA;GACG,aAAa;GACb,uBAAuB;GACvB,aAAa;GACb,aAAa;GACb,kDAAkD;GAClD,oCAAoC;GACpC,SAAS;AACZ;;AAEA;GACG,gCAAgC;;AAEnC;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;;IAEnB,WAAW;;IAEX,mBAAmB;AACvB;;AAEA;GACG,wBAAwB;GACxB,oBAAoB;GACpB,oBAAoB;GACpB,gBAAgB;GAChB,eAAe;AAClB;AACA;GACG,uBAAuB;GACvB,oBAAoB;GACpB,oBAAoB;GACpB,gBAAgB;GAChB,eAAe;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;;;AAIA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;;2BAE2B;;AAE3B;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;;2BAE2B;;AAE3B;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;2BAE2B;;AAE3B;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;;IAE/B,oCAAoC;IACpC,iBAAiB;;IAEjB,YAAY;IACZ,mBAAmB;;IAEnB,yBAAyB;IACzB,YAAY;;IAEZ,eAAe;;IAEf,yBAAyB;;IAEzB,yCAAyC;;IAEzC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;2BAE2B;;AAE3B;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,WAAW;AACf;;AAEA;;IAEI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;;IAElB,eAAe;IACf,iBAAiB;;IAEjB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;2BAE2B;;AAE3B;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,sBAAsB;IACtB,kBAAkB;;IAElB,yBAAyB;IACzB,YAAY;;IAEZ,eAAe;IACf,iBAAiB;;IAEjB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;2BAE2B;;AAE3B;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,uBAAuB;;IAEvB,gBAAgB;IAChB,aAAa;;IAEb,eAAe;IACf,yBAAyB;;IAEzB,yBAAyB;IACzB,kBAAkB;;IAElB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;2BAE2B;;AAE3B;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;;IAErB,uBAAuB;;IAEvB,kBAAkB;;IAElB,kBAAkB;;IAElB,iBAAiB;IACjB,cAAc;;IAEd,wCAAwC;AAC5C;;AAEA;;2BAE2B;;AAE3B;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB;AACJ;;AAEA;IACI,uBAAuB;;IAEvB,YAAY;IACZ,cAAc;;IAEd,aAAa;;IAEb,mBAAmB;;IAEnB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;2BAE2B;;AAE3B;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;;IAEzB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;gCAEgC;AAChC;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;AACtB;;AAEA;;gCAEgC;;AAEhC;IACI,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,oBAAoB;AACxB;AACA;IACI,gBAAgB;;IAEhB,mBAAmB;IACnB,mBAAmB;;IAEnB,eAAe;;IAEf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;;IAElB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB,kBAAkB;IAClB,mBAAmB;;IAEnB,mBAAmB;IACnB,mBAAmB;;IAEnB,iBAAiB;IACjB,gBAAgB;;IAEhB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;;AAGA;;GAEG;MACG,wBAAwB;MACxB,WAAW;MACX,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;GAC1B;;GAEA;MACG,gCAAgC;MAChC,WAAW;GACd;;GAEA;MACG,gCAAgC;MAChC,WAAW;GACd;;GAEA;MACG,+BAA+B;MAC/B,oBAAoB;MACpB,kBAAkB;GACrB;;GAEA;MACG,uBAAuB;MACvB,WAAW;MACX,QAAQ;GACX;GACA;MACG,WAAW;GACd;GACA;MACG,oBAAoB;GACvB;;GAEA;MACG,WAAW;GACd;;GAEA;MACG,WAAW;MACX;GACH;;;;;;;;AAQH","sourcesContent":["/* =========================\n   Global Layout\n========================= */\n\n* {\n    box-sizing: border-box;\n}\n\nbody {\n    background-color: #f4f6f8;\n    font-family: Arial, Helvetica, sans-serif;\n    margin: 0;\n    padding: 0;\n}\n\n\n.gameLayout {\n   display: grid;\n   justify-content: center;\n   padding: 1rem;\n   margin: 0 2vw;\n   grid-template-columns: repeat(12, [col-start] 1fr);\n   grid-template-rows: repeat(12, auto);\n   gap: 20px;\n}\n\n.gameLayout > * {\n   grid-column: col-start / span 12;\n   \n}\n.timer {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n   \n    width: 100%;\n\n    margin-bottom: 1rem;\n}\n\n.playerCountRight { \n   grid-column: 11 / span 2;\n   grid-row: 1 / span 1;\n   justify-self: center;\n   font-weight: 800;\n   font-size: 20px;\n}\n.playerCountLeft { \n   grid-column: 1 / span 2;\n   grid-row: 2 / span 1;\n   justify-self: center;\n   font-weight: 800;\n   font-size: 20px;\n}\n\n.shuffleBtn {\n    width: 75px;\n    height: 75px;\n    padding: 0;\n    margin: 0;\n    border-radius: 12px;\n}\n.shuffleImg {\n    object-fit: contain;\n    width: 100%;\n    height: 100%;\n    justify-self: center;\n}\n\n\n\n@media (max-width: 768px) {\n    .timer {\n        justify-content: center;\n    }\n}\n\n/* =========================\n   Points\n========================= */\n\n.points {\n    text-align: center;\n    margin-top: 20px;\n    color: #1e293b;\n}\n\n.points h2 {\n    margin: 0;\n    font-size: 2rem;\n}\n\n/* =========================\n   Word Count Sidebar\n========================= */\n\n.wordCountSidebar {\n    width: 220px;\n    justify-self: center;\n}\n\n.WordCountPanel {\n    background-color: white;\n    border-radius: 15px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);\n    border: 1px solid #d6dde5;\n    overflow: hidden;\n}\n\n.WordCountPanel h3 {\n    margin: 0;\n    padding: 12px;\n    background-color: #865AA6;\n    color: white;\n    text-align: center;\n}\n\n.WordCountRow {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 14px;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.WordCountRow:last-child {\n    border-bottom: none;\n}\n\n.WordCountRow:nth-child(even) {\n    background-color: #f8fafc;\n}\n\n/* =========================\n   Letter Display\n========================= */\n\n.letterRow {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n    margin-top: 30px;\n}\n\n.letter {\n    width: clamp(50px, 10vw, 75px);\n    height: clamp(50px, 10vw, 75px);\n\n    font-size: clamp(1.25rem, 4vw, 2rem);\n    font-weight: bold;\n\n    border: none;\n    border-radius: 12px;\n\n    background-color: #d7aef2;\n    color: black;\n\n    cursor: pointer;\n\n    transition: all 0.2s ease;\n\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);\n\n    text-transform: uppercase;\n}\n\n.letter:hover {\n    background-color: #1d4ed8;\n    transform: translateY(-2px);\n}\n\n.letter:active {\n    transform: scale(0.95);\n}\n\n.used {\n    background-color: #865AA6;\n}\n\n/* =========================\n   Buttons\n========================= */\n\n.buttons {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 1rem;\n    width: 100%;\n}\n\n.start,\n.end {\n    color: white;\n    border: none;\n    border-radius: 8px;\n    padding: 12px 24px;\n\n    font-size: 1rem;\n    font-weight: bold;\n\n    cursor: pointer;\n    transition: 0.2s ease;\n}\n\n.start {\n    background-color: #1A78A3;\n}\n\n.end {\n    background-color: #91191d;\n}\n\n.start:hover {\n    background-color: #16698e;\n}\n\n.end:hover {\n    background-color: #7c1519;\n}\n\n.start:active,\n.end:active {\n    transform: scale(0.97);\n}\n\n/* =========================\n   Letter Count Buttons\n========================= */\n\n.letterCountRow {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 15px;\n    z-index: 1;\n}\n\n.LetterCountButton {\n    width: 45px;\n    height: 45px;\n\n    border: 1px solid #888;\n    border-radius: 8px;\n\n    background-color: #6b7280;\n    color: white;\n\n    font-size: 1rem;\n    font-weight: bold;\n\n    cursor: pointer;\n    transition: 0.2s ease;\n}\n\n.LetterCountButton:hover {\n    background-color: #4b5563;\n}\n\n.LetterCountButton:active {\n    transform: scale(0.95);\n}\n\n/* =========================\n   Guess Input\n========================= */\n\n.guess {\n    text-align: center;\n}\n\n.guess label {\n    font-size: 1.1rem;\n    font-weight: bold;\n    color: #334155;\n}\n\n.guess input {\n    width: min(300px, 90vw);\n\n    margin-top: 10px;\n    padding: 10px;\n\n    font-size: 1rem;\n    text-transform: uppercase;\n\n    border: 2px solid #cbd5e1;\n    border-radius: 8px;\n\n    outline: none;\n}\n\n.guess input:focus {\n    border-color: #2563eb;\n}\n\n/* =========================\n   Response Messages\n========================= */\n\n.guessText {\n    text-align: center;\n    min-height: 40px;\n    margin-top: 15px;\n}\n\n.guessText p {\n    display: inline-block;\n\n    background-color: white;\n\n    border-radius: 8px;\n\n    padding: 10px 20px;\n\n    font-weight: bold;\n    color: #334155;\n\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n/* =========================\n   End Game Screen\n========================= */\n\n.GameEnd {\n    margin-top: 25px;\n    display: flex;\n    justify-content: center;\n    grid-row: 9\n}\n\n.EndResult {\n    background-color: white;\n\n    width: 600px;\n    max-width: 95%;\n\n    padding: 25px;\n\n    border-radius: 15px;\n\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);\n}\n\n.EndResult h1 {\n    text-align: center;\n    color: #1e293b;\n}\n\n/* =========================\n   Scrollable Word List\n========================= */\n\n.WordList {\n    margin-top: 20px;\n    max-height: 450px;\n    overflow-y: auto;\n    padding-right: 8px;\n}\n\n.WordList h3 {\n    margin-bottom: 5px;\n    color: #334155;\n}\n\n.WordList::-webkit-scrollbar {\n    width: 8px;\n}\n\n.WordList::-webkit-scrollbar-thumb {\n    background-color: #1A78A3;\n\n    border-bottom: 1px solid #d1d9e0;\n}\n\n.Word {\n    display: block;\n    padding-left: 15px;\n}\n\n.Word.guessed {\n    background-color: #a3e635;\n    color: black;\n    font-weight: bold;\n}\n\n/* ============================\n      SETTINGS MENU\n============================== */\n.settingsForm {\n    background: #1e1e1e;\n    padding: 1.5rem;\n    border-radius: 12px;\n    border: 1px solid #444;\n    max-width: 300px;\n    color: white;\n}\n\n.settingsForm h3 {\n    margin-top: 0;\n    margin-bottom: 1rem;\n    text-align: center;\n}\n\n.settingsGroup {\n    margin-bottom: 1rem;\n}\n\n.settingsGroup label {\n    display: block;\n    font-weight: bold;\n    margin-bottom: 0.25rem;\n}\n\n.settingsGroup input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 0.6rem;\n    border: 1px solid #555;\n    border-radius: 6px;\n    background-color: #2c2c2c;\n    color: white;\n    font-size: 1rem;\n}\n\n.settingsGroup input:focus {\n    outline: none;\n    border-color: #4cafef;\n    box-shadow: 0 0 5px rgba(76, 175, 239, 0.5);\n}\n\n.settingsSave {\n    width: 100%;\n    padding: 0.75rem;\n    border: none;\n    border-radius: 8px;\n    background-color: #28a745;\n    color: white;\n    font-size: 1rem;\n    font-weight: bold;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.settingsSave:hover {\n    background-color: #218838;\n}\n\n.settingsSave:active {\n    transform: scale(0.98);\n}\n.settingsGroup input::placeholder {\n    color: #999;\n    opacity: 1;\n    font-style: italic;\n}\n\n/* ===========================\n      MOBILE LAYOUT \n============================== */\n\n.gameId {\n    position: sticky;\n    top: 10px;\n    width: 115px;\n    height: 35px;\n    left: 15px;\n    background: rgba(0, 0, 0, 0.85);\n    color: white;\n    padding: 8px 14px;\n    border-radius: 8px;\n    font-size: 0.95rem;\n    font-weight: 700;\n    letter-spacing: 1px;\n    z-index: 1000;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n    grid-row: 1 / span 1;\n}\n.leaderboard {\n    margin-top: 2rem;\n\n    background: #ffffff;\n    border-radius: 16px;\n\n    padding: 1.5rem;\n\n    max-width: 400px;\n    margin-left: auto;\n    margin-right: auto;\n\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);\n}\n\n.leaderboard h2 {\n    text-align: center;\n    margin-bottom: 1rem;\n}\n.player {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    padding: 12px 16px;\n    margin-bottom: 10px;\n\n    background: #f4f4f4;\n    border-radius: 10px;\n\n    font-size: 1.1rem;\n    font-weight: 600;\n\n    transition: all 0.2s ease;\n}\n\n.player:hover {\n    background: #e9e9e9;\n    transform: scale(1.02);\n}\n\n\n@media (min-width: 768px) {\n\n   .timer {\n      grid-column: 10 / span 3;\n      grid-row: 1;\n      margin-bottom: 0;\n      align-items: center;\n      justify-content: center;\n   }\n   \n   .points { \n      grid-column: col-start / span 12;\n      grid-row: 2;\n   }\n\n   .letterRow {\n      grid-column: col-start / span 12;\n      grid-row: 3;\n   }\n\n   .wordCountSidebar {\n      grid-column: col-start / span 3;\n      grid-row: 4 / span 9;\n      justify-self: left;\n   }\n\n   .buttons {\n      grid-column: 4 / span 6;\n      grid-row: 5;\n      gap: 2em;\n   }\n   .start .end {\n      width: 12vw;\n   }\n   .guess {\n      grid-row: 6 / span 2;\n   }\n\n   .guessText {\n      grid-row: 8;\n   }\n\n   .letterCountRow {\n      grid-row: 6;\n      z-index: 1\n   }\n   \n   \n\n   \n\n   \n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gameLayout": `Anagrams_gameLayout__0t7Jp`,
	"timer": `Anagrams_timer__zoPa-`,
	"playerCountRight": `Anagrams_playerCountRight__pnzw0`,
	"playerCountLeft": `Anagrams_playerCountLeft__SemmF`,
	"shuffleBtn": `Anagrams_shuffleBtn__DQwKe`,
	"shuffleImg": `Anagrams_shuffleImg__bgWdI`,
	"points": `Anagrams_points__a59dN`,
	"wordCountSidebar": `Anagrams_wordCountSidebar__ZFgsV`,
	"WordCountPanel": `Anagrams_WordCountPanel__7yChM`,
	"WordCountRow": `Anagrams_WordCountRow__olj9K`,
	"letterRow": `Anagrams_letterRow__2F7cl`,
	"letter": `Anagrams_letter__Ovodk`,
	"used": `Anagrams_used__CQuqt`,
	"buttons": `Anagrams_buttons__lI10n`,
	"start": `Anagrams_start__mu77T`,
	"end": `Anagrams_end__bwGPy`,
	"letterCountRow": `Anagrams_letterCountRow__X4vQN`,
	"LetterCountButton": `Anagrams_LetterCountButton__o2DUC`,
	"guess": `Anagrams_guess__LEpHK`,
	"guessText": `Anagrams_guessText__F-LMh`,
	"GameEnd": `Anagrams_GameEnd__E2YJx`,
	"EndResult": `Anagrams_EndResult__5ckRW`,
	"WordList": `Anagrams_WordList__g31cf`,
	"Word": `Anagrams_Word__YEYQf`,
	"guessed": `Anagrams_guessed__Y8f0n`,
	"settingsForm": `Anagrams_settingsForm__F6k-c`,
	"settingsGroup": `Anagrams_settingsGroup__OpJm0`,
	"settingsSave": `Anagrams_settingsSave__0Yq+i`,
	"gameId": `Anagrams_gameId__bS6fz`,
	"leaderboard": `Anagrams_leaderboard__E2+1S`,
	"player": `Anagrams_player__9vXlL`
};
export default ___CSS_LOADER_EXPORT___;
